const ROUTES = {
  /**
   * Rutas para Audi Nuevo - Sitio Web
   */
  AUDINUEVOGENERAL: process.env.PUBLIC_URL + "/salesforce/audi-nuevo/",
  AUDINUEVOMODELO: ":modelPathName",
  AUDINUEVOMODELOPREVENTALEALTAD: "lealtad/:modelPathName",
  AUDINUEVOMODELOPREVENTACONQUISTA: "conquista/:modelPathName",
  AUDINUEVOTHANKYOUEMPTY: "thank-you",
  AUDINUEVOTHANKYOU: "thank-you/:modelPathName",
  AUDINUEVOTHANKYOULEALTAD: "thank-you/lealtad/:modelPathName",
  AUDINUEVOTHANKYOUCONQUISTA: "thank-you/conquista/:modelPathName",
  AUDINUEVOFORMNOTFOUND: "not-found",
  /**
   * Rutas para Audi Driving Experience
   */
  DRIVINGEXPERIENCEGENERAL: process.env.PUBLIC_URL + "/driving-experience/",
  DRIVINGEXPERIENCETHANKYOUEMPTY: "thank-you",

  /**
   * Rutas para Citas de Servicio
   */
  CITASSERVICIOEMPTY: process.env.PUBLIC_URL + "/citas-de-servicio/agendar",
  CITASSERVICIO: process.env.PUBLIC_URL + "/citas-de-servicio/agendar/:concesionaria",
  CITASSERVICIOCANCELARCITAEMPTY: process.env.PUBLIC_URL + "/citas-de-servicio/cancelar/",
  CITASSERVICIOCANCELARCITA: process.env.PUBLIC_URL + "/citas-de-servicio/cancelar/:idcita/:idconcesionaria/:uuid/:correo/:cliente",
  CITASSERVICIOTHANKYOUEMPTY: process.env.PUBLIC_URL + "/citas-de-servicio/thank-you",
  CITASSERVICIOTHANKYOU: process.env.PUBLIC_URL + "/citas-de-servicio/thank-you/:concesionaria",
  /**
   * Rutas para Configurador
   */
  CONFIGURADORGENERAL: process.env.PUBLIC_URL + "/salesforce/configurador/",
  AUDICONFIGURADORBTN: process.env.PUBLIC_URL + "/configurador/btn",
  AUDICONFIGURADOR: "",
  AUDICONFIGURADORTHANKYOU: "thank-you",
  AUDICONFIGURADORTHANKYOUEMPY: "thank-you",
  /**
   * Rutas para Compramos tu Auto
   */
  COMPRAMOSTUAUTOEMPTY: process.env.PUBLIC_URL + "/compramos-tu-auto",
  COMPRAMOSTUAUTO: process.env.PUBLIC_URL + "/compramos-tu-auto/:concesionaria",
  COMPRAMOSTUAUTOTHANKYOUEMPTY: process.env.PUBLIC_URL + "/compramos-tu-auto/thank-you",
  COMPRAMOSTUAUTOTHANKYOU: process.env.PUBLIC_URL + "/compramos-tu-auto/thank-you/:concesionaria",


  /**
   * Rutas para Audi Campaign - Ducatti
   */
  CAMPAIGNDUCATI: process.env.PUBLIC_URL + "/campaign/ducati/",
  CAMPAIGNDUCATITHANKYOUEMPTY: "thank-you",

  /**
   * Rutas para VTP Nuevos / Usados
   */
  VTPNUEVOS: process.env.PUBLIC_URL + "/salesforce/vtp/new-car/",
  VTPNUEVOSVINID: ":vinId",
  VTPNUEVOSTHANKYOUEMPTY: "thank-you",
  VTPNUEVOSTHANKYOU: "thank-you/:vinId",
  VTPUSADOS: process.env.PUBLIC_URL + "/salesforce/vtp/certified-plus/",
  VTPUSADOSCARID: ":carId",
  VTPUSADOSTHANKYOUEMPTY: "thank-you",
  VTPUSADOSTHANKYOU: "thank-you/:carId",

  /**
   * Rutas para Prueba de Manejo
   */
  PRUEBADEMANEJOEMPTY: process.env.PUBLIC_URL + "/prueba-de-manejo",
  PRUEBADEMANEJO: process.env.PUBLIC_URL + "/prueba-de-manejo/:concesionaria",
  PRUEBADEMANEJOTHANKYOUEMPTY: process.env.PUBLIC_URL + "/prueba-de-manejo/thank-you",
  PRUEBADEMANEJOTHANKYOU: process.env.PUBLIC_URL + "/prueba-de-manejo/thank-you/:concesionaria",

  /**
   * Rutas para Contacto
   */
  CONTACTOSUGERENCIA: process.env.PUBLIC_URL + "/contacto/sugerencia",
  CONTACTOINFORMACION: process.env.PUBLIC_URL + "/contacto/informacion",
  CONTACTORH: process.env.PUBLIC_URL + "/contacto/rh",
  CONTACTOQUEJAS: process.env.PUBLIC_URL + "/contacto/quejas",
  CONTACTOOTRO: process.env.PUBLIC_URL + "/contacto/otro",
  CONTACTOPOSTVENTA: process.env.PUBLIC_URL + "/contacto/postventa",
  CONTACTOSUGERENCIATHANKYOU: process.env.PUBLIC_URL + "/contacto/sugerencia/thank-you",
  CONTACTOINFORMACIONTHANKYOU: process.env.PUBLIC_URL + "/contacto/informacion/thank-you",
  CONTACTORHTHANKYOU: process.env.PUBLIC_URL + "/contacto/rh/thank-you",
  CONTACTOQUEJASTHANKYOU: process.env.PUBLIC_URL + "/contacto/quejas/thank-you",
  CONTACTOOTROTHANKYOU: process.env.PUBLIC_URL + "/contacto/otro/thank-you",
  CONTACTOPOSTVENTATHANKYOU: process.env.PUBLIC_URL + "/contacto/postventa/thank-you",


  /**
   * Rutas para Accesorios / Collection
   */
  ACCESORIOSGENERAL: process.env.PUBLIC_URL + "/accesorios/",
  ACCESORIOSFLIPBOOK: "",
  ACCESORIOSFLIPTHANKYOU: "thank-you/:formName",
  ACCESORIOS: ":idArticle",
  ACCESORIOSTHANKYOU: "thank-you",
  COLLECTIONGENERAL: process.env.PUBLIC_URL + "/collection/",
  COLLECTIONFLIPBOOK: "",
  COLLECTIONFLIPTHANKYOU: "thank-you/:formName",
  COLLECTION: ":idArticle",
  COLLECTIONTHANKYOU: "thank-you",
};

export default ROUTES;